import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { FiInfo } from 'react-icons/fi';
import { getCookieConsent, setCookieConsent, subscribeCookieConsent } from '../../legal/cookieConsent';
import './CookieNotice.css';

export default function CookieNotice() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    setVisible(!getCookieConsent());
    return subscribeCookieConsent((value) => setVisible(!value));
  }, []);

  const acceptAll = () => {
    setCookieConsent('all');
    setVisible(false);
  };

  const acceptEssential = () => {
    setCookieConsent('essential');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      className="cookie-banner"
      role="dialog"
      aria-live="polite"
      aria-label="Настройки cookie"
    >
      <div className="cookie-banner__icon" aria-hidden="true">
        <FiInfo />
      </div>

      <div className="cookie-banner__body">
        <p className="cookie-banner__title">Мы используем cookies</p>
        <p className="cookie-banner__text">
          Необходимые cookies — для корзины, входа и безопасности. Аналитика (Яндекс.Метрика,
          включая вебвизор) — только с вашего согласия. Подробнее — в{' '}
          <Link to="/cookies">политике cookie</Link>.
        </p>
      </div>

      <div className="cookie-banner__actions">
        <button type="button" className="cookie-banner__link" onClick={acceptEssential}>
          Только необходимые
        </button>
        <button type="button" className="cookie-banner__accept" onClick={acceptAll}>
          Принять все
        </button>
      </div>
    </div>
  );
}
